<div class="container-fluid">

  <div class="pageheader d-flex align-items-center justify-content-between mb-2">
    <h4 class="d-flex align-items-center mb-1">Company Groups</h4>
  </div>

  <app-card>
    <div class="d-flex justify-content-end mb-2">
      <button type="button" class="btn btn-success btn-sm" (click)="addCompanyGroup()">
        <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
        Add Company
      </button>
    </div>

    <app-table
      [columns]="columns"
      [data]="companyGroups"
      [totalCount]="resultsLength"
      [pageSize]="20"
      [loading]="isLoading"
      [clickableRows]="true"
      (searchChange)="onSearch($event)"
      [initialFilterValues]="{ active: '{{bool}}true' }"
      (rowClick)="editCompanyGroup($event)">

        <ng-template tableCell="active" let-row>
          <span class="badge" [ngClass]="row.active ? 'bg-success' : 'bg-danger'">
            {{ row.active ? 'Active' : 'Inactive' }}
          </span>
        </ng-template>

      </app-table>

  </app-card>
</div>